import { PlatformLocation } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
    DEFAULT_CURRENCY_CODE,
    enableProdMode,
    importProvidersFrom,
    inject,
    Injector,
    LOCALE_ID,
    provideAppInitializer,
} from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appInitializeFaro } from '@app/shared/observability/faro-initializer-service';
import { GrafanaConfigurationService } from '@app/shared/observability/grafana-configuration.service';
import Lara from '@primeng/themes/lara';
import { FixedAssetsCommonModule } from '@shared/common/common.module';
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { providePrimeNG } from 'primeng/config';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './polyfills';
import { RootRoutingModule } from './root-routing.module';
import { RootComponent } from './root.component';
import {
    appInitializerFactory,
    getCurrencyCode,
    getCurrentLanguage,
    getRemoteServiceBaseUrl,
} from './root.module';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(RootComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            AppModule,
            FixedAssetsCommonModule.forRoot(),
            ServiceProxyModule,
            RootRoutingModule,
            NgxSpinnerModule
        ),
        provideAnimations(),
        { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
        provideAppInitializer(() =>
            appInitializerFactory(inject(Injector), inject(PlatformLocation))()
        ),
        {
            provide: LOCALE_ID,
            useFactory: getCurrentLanguage,
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useFactory: getCurrencyCode,
            deps: [Injector],
        },
        provideAppInitializer(() =>
            appInitializeFaro(inject(GrafanaConfigurationService).getConfiguration())
        ),
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Lara,
                options: {
                    darkModeSelector: '[data-bs-theme="dark"]',
                },
            },
        }),
    ],
});
